import {
  CarFront,
  LayoutDashboard,
  Users,
  Wallet,
} from "lucide-react";
import { cn } from "@/lib/utils";
import { APP_LOGO_PATH } from "@/lib/constants";

export type AppShellHighlight = "dashboard" | "garagem" | "financeiro" | "clientes";

type Item = { key: AppShellHighlight; icon: React.ElementType; label: string };

const SIDEBAR_ITEMS: Item[] = [
  { key: "dashboard", icon: LayoutDashboard, label: "Dashboard" },
  { key: "garagem", icon: CarFront, label: "Estoque" },
  { key: "clientes", icon: Users, label: "Clientes" },
  { key: "financeiro", icon: Wallet, label: "Financeiro" },
];

type AppShellMockProps = {
  highlight: AppShellHighlight;
  children: React.ReactNode;
};

/**
 * Réplica visual enxuta do layout autenticado: sidebar escura + área principal.
 */
export const AppShellMock = ({ highlight, children }: AppShellMockProps) => (
  <div className="flex h-full min-h-0 w-full overflow-hidden rounded-b-[inherit] bg-background text-left">
    <aside
      className="flex w-11 shrink-0 flex-col border-r border-zinc-800 bg-zinc-950 md:w-12"
      aria-hidden
    >
      <div className="flex items-center justify-center border-b border-zinc-800 py-2">
        <img src={APP_LOGO_PATH} alt="" className="h-6 w-6 object-contain" />
      </div>
      <nav className="flex flex-1 flex-col gap-1 px-1.5 py-2">
        {SIDEBAR_ITEMS.map((item) => {
          const Icon = item.icon;
          const active = item.key === highlight;
          return (
            <div
              key={item.label}
              className={cn(
                "flex h-9 items-center justify-center rounded-lg transition-all duration-200",
                active
                  ? "bg-linear-to-r from-[#2520a8] to-[#433bff] text-white shadow-[0_0_12px_rgba(67,59,255,0.2)]"
                  : "text-zinc-400"
              )}
              title={item.label}
            >
              <Icon className={cn("h-4 w-4 shrink-0", active ? "text-white" : "")} strokeWidth={active ? 2.5 : 2} aria-hidden />
            </div>
          );
        })}
      </nav>
      <div className="flex justify-center border-t border-zinc-800 py-2">
        <div className="flex h-7 w-7 items-center justify-center rounded-full border border-zinc-700 bg-zinc-800 text-[9px] font-semibold text-zinc-300">
          GM
        </div>
      </div>
    </aside>
    <div className="min-h-0 min-w-0 flex-1 overflow-hidden">{children}</div>
  </div>
);
